import { Button, Checkbox, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { RiAddLargeLine } from "react-icons/ri";
import { ProductAPI } from '../../api/ProductAPI';
import { useSelector } from "react-redux";
import { AccountSetupAPI } from '../../api/AccountSetupAPI';
import { calendarTypePayload, isValidSetupData, planStepPayload } from '../../util/accountSetup';
import { currentPlanName, FEE_FALLBACK, isSelectedPlatformPlan, platformFeeLabel } from '../../util/accountSetupCopy';
import {
  catalogFreePlan,
  catalogPaidPlan,
  freeFeePhrase,
  isFreeClubPlan,
  planSwitchDates,
  switchApiErrorMessage,
  platformUpgradeCheckoutState,
  switchToFreeBody,
  upgradeToPaidSwitchBody,
} from '../../util/planSwitchCopy';
import { PlanCompare } from '../account-setup/SetupGuide';
import { clubShowsClubPlayerCatalog, clubShowsCustomerPlans, clubShowsHourlyCourtPlans, hasClubCapabilityModel } from '../../util/clubCapabilities';
import PlanSwitchPanel from './PlanSwitchPanel';
import { SubscriptionAPI } from '../../api/SubscriptionAPI';
import { isClubOwner } from '../../util/UserRoles';
import { PlaftFormAPI } from '../../api/PlatformAPI';
import { PaymentAPI } from '../../api/PaymentAPI';
import { PayoutAPI } from '../../api/PayoutAPI';
import {
  FINANCIAL_VENDOR_PATH,
  HOURLY_COURT_VENDOR_REQUIRED,
  clubNeedsConnectToGetPaid,
  isFinancialVendorVerified,
} from '../../util/financialVendorGate';
import { GrClose } from "react-icons/gr";
import SecondLoader from '../../component/SecondLoader';
import { Privileges } from '../../util/PrivilegeConstants';
import AddPlanComponent from './AddPlanComponent';
import { useLocation, useNavigate } from 'react-router';
import { AuthContext } from '../auth/AuthContext';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../redux/reducer/rootReducer';
import CustomDialog from '../CustomComponents/CustomDialog/CustomDialog.jsx';
import { PrivilegeAPI } from '../../api/PrivilegesAPI.js';
import Loader from '../../component/Loader.jsx';
import PlanCard from '../Coach/Plan/PlanCard.jsx';
import SubDetailsCard from '../Coach/Plan/SubDetailsCard.jsx'


function PlanPageSection({ step, kicker, title, lead, testId, className = "", children }) {
  return (
    <section className={`plan-page-section${className ? ` ${className}` : ""}`} data-testid={testId}>
      {(kicker || title || lead) && (
        <div className="plan-page-section-head">
          {step ? <span className="plan-page-section-step" aria-hidden="true">{step}</span> : null}
          <div className="plan-page-section-copy">
            {kicker ? <p className="plan-page-section-kicker">{kicker}</p> : null}
            {title ? <h2 className="plan-page-section-title">{title}</h2> : null}
            {lead ? <p className="plan-page-section-lead">{lead}</p> : null}
          </div>
        </div>
      )}
      {children}
    </section>
  );
}

const PlanSetting = ({ setIsUpdated, setSubscriptionStatus, subscriptionStatus, applySetupData }) => {
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const stepperInStore = useSelector((state) => state.stepper);
  const stepperConfigId = stepperInStore.configId;
  const [defaultPayCard, setDefaultPayCard] = useState({});
  const [isYear, setIsYear] = useState({});
  const [openAdd, setOpenAdd] = useState(false);
  const [refreshSubscription, setRefreshSubscription] = useState(false);
  const [refreshProduct, setRefreshProduct] = useState(false);
  const [planType, setPlanType] = useState('');
  const [errorFields, setErrorFields] = useState({ membershipAmount: false, planName: false, advanceBooking: false });
  const [weekDayAmount, setWeekDayAmount] = useState([]);
  const [weekEndAmount, setWeekEndAmount] = useState([]);
  const [registrationFee, setRegistrationFee] = useState('0');
  const [regError, setRegError] = useState(false);
  const [isAdvanceBooking, setIsAdvanceBooking] = useState(false);
  const [weekdayInfo, setWeekdayInfo] = useState([{ startTime: '', endTime: '', amount: '' }]);
  const [weekendInfo, setWeekendInfo] = useState([{ startTime: '', endTime: '', amount: '' }]);
  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    loading5: false,
    loading6: false,
    loading7: false,
  });
  const [isApplyFee, setIsApplyFee] = useState(false);
  const [data, setData] = useState([]);
  const [apiResData, setApiResData] = useState({
    subscriptionFromPlatform: null,
    subscriptionDetails: [],
    platformProducts: [],
  })
  const { state } = useLocation();
  const navigate = useNavigate();
  const { getCurrentUser } = useContext(AuthContext);

  const [isPlanRequired, setIsPlanRequired] = useState(false);
  const [privileges, setPrivileges] = useState({});
  const [planFees, setPlanFees] = useState({
    free: FEE_FALLBACK.FREE,
    paid: FEE_FALLBACK.PAID,
    freeFee: null,
  });
  const [setupPlan, setSetupPlan] = useState(null);
  const [hourlyVendorReady, setHourlyVendorReady] = useState(null);

  const dispatch = useDispatch();


  const setApiData = (key, result) => {
    setApiResData((prev) => ({
      ...prev,
      [key]: result
    }))
  };

  const startLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: true
    }))
  };

  const finishLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: false
    }))
  };
  const handleChangeDuration = (val, planId) => {
   //console.log('Toggle Plan ID:', planId, 'to', val);
    setIsYear((prev) => ({
      ...prev,
      [planId]: val,
    }));
  };
  //Update stepper details
  const updateStepper = async () => {
    const response = await AccountSetupAPI.postStepper(planStepPayload(selectedClub.clubId));
    if (isValidSetupData(response?.Data) && typeof applySetupData === 'function') {
      applySetupData(response.Data);
      return;
    }
    setIsUpdated(true);
  }

  const handleData = (event) => {
    setWeekDayAmount([]);
    setWeekEndAmount([]);
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  }
  const handleWeekInfo = (index, event) => {
    setWeekDayAmount([]);
    const { name, value } = event.target;
    setWeekdayInfo((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs[index][name] = value;
      return updatedInputs;
    });
  }


  const handleRemoveWeekInfo = (idx) => {
    const afterRemove = weekdayInfo.filter((info, index) => index != idx);
    setWeekdayInfo(afterRemove);
  }
  const handleWeekendInfo = (index, event) => {
    setWeekEndAmount([]);
    const { name, value } = event.target;
    setWeekendInfo((prevInputs) => {
      const updatedInputs = [...prevInputs];
      updatedInputs[index][name] = value;
      return updatedInputs;
    });
  }
  const handleRemoveWeekendInfo = (idx) => {
    const afterRemove = weekendInfo.filter((info, index) => index != idx);
    setWeekendInfo(afterRemove);
  }
  const getRegistrationFee = async () => {
    try {
      startLoading("loading5")
      const response = await AccountSetupAPI.getRegistrationFeeDetails(selectedClub.clubId);
      setRegistrationFee(response.Data);
      finishLoading("loading5")
    } catch (error) {
      finishLoading("loading5")
    }
  }
  const findAllPrivileges = async () => {
    try {
      startLoading("loading6")
      const reqObj = {
        userId: userInfo.userId,
        featureName: Object.keys(Privileges)[7]
      }
      const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
      setPrivileges(response.Data);
    } catch (error) {
      console.error(error);
    } finally {
      finishLoading("loading6");
    }
  };
  const checkHourlyVendor = async () => {
    if (!clubNeedsConnectToGetPaid(selectedClub) || !userInfo?.userId || !selectedClub?.clubId) {
      setHourlyVendorReady(true);
      return;
    }
    try {
      const verified = await PayoutAPI.postIsUserAdminVerified({
        userId: userInfo.userId,
        clubId: selectedClub.clubId,
      });
      setHourlyVendorReady(isFinancialVendorVerified(verified));
    } catch (error) {
      setHourlyVendorReady(false);
    }
  };
  useEffect(() => {
    if (state?.reload) {
      getCurrentUser();
    }
    if (state?.updateFirstStep) {
      updateStepper();
    }
  }, []);

  useEffect(() => {
    if (userInfo?.userId) {

      setIsPlanRequired(selectedClub.isPlanRequired); 
      fetchAllPlatformProducts();
      fetchPlanFees();
      fetchSetupPlan();
      fetchDefaultPaymentMethodData();
      getRegistrationFee();
      findAllPrivileges();
      checkHourlyVendor();
    }
  }, [userInfo?.userId, selectedClub?.clubId]);

  useEffect(() => {
    if (userInfo?.userId) {
      fetchAllProducts();
    }
    refreshProduct && setRefreshProduct(false);
  }, [refreshProduct, userInfo?.userId]);

  useEffect(() => {
    if (userInfo?.userId) {
      findSubscription();
    }
    refreshSubscription && setRefreshSubscription(false);
  }, [refreshSubscription, userInfo?.userId]);

  const fetchAllProducts = async () => {
    try {
      startLoading("loading1");
      const allProducts = await ProductAPI.getAllProducts(
        userInfo?.userId,
        selectedClub.clubId
      );
      setApiData("subscriptionDetails", allProducts.Data);
      finishLoading("loading1");
    } catch (error) {
      finishLoading("loading1")
      console.error("error in products", error)
    }
  };
  const fetchAllPlatformProducts = async () => {
    try {
      startLoading("loading2")
      const allProducts = await PlaftFormAPI.getAllPlatformClubReservationPlans();
      setApiData("platformProducts", allProducts.Data);
      finishLoading("loading2");
    } catch (error) {
      console.error(error);
      finishLoading("loading2")
    }
  };
  const fetchPlanFees = async () => {
    try {
      const [freeFee, paidFee] = await Promise.all([
        PlaftFormAPI.getPlatformFee("FREE"),
        PlaftFormAPI.getPlatformFee("PAID"),
      ]);
      setPlanFees({
        free: platformFeeLabel(freeFee?.Data, FEE_FALLBACK.FREE),
        paid: platformFeeLabel(paidFee?.Data, FEE_FALLBACK.PAID),
        freeFee: freeFee?.Data || null,
      });
    } catch (error) {
      setPlanFees({
        free: FEE_FALLBACK.FREE,
        paid: FEE_FALLBACK.PAID,
        freeFee: null,
      });
    }
  };
  const fetchSetupPlan = async () => {
    if (!selectedClub?.clubId || typeof applySetupData === "function") {
      return;
    }
    try {
      const response = await AccountSetupAPI.getAllSteps(selectedClub.clubId);
      if (isValidSetupData(response?.Data)) {
        setSetupPlan(response.Data);
      }
    } catch (error) {
      setSetupPlan(null);
    }
  };
  const fetchDefaultPaymentMethodData = async () => {
    try {
      startLoading("loading4")
      const defaultPaymentMethod = await PaymentAPI.fetchDefaultPaymentMethodData(userInfo?.userId, selectedClub.clubId);
      setDefaultPayCard(defaultPaymentMethod.Data)
      finishLoading("loading4");
    } catch (error) {
      console.error(error);
      finishLoading("loading4")
    }
  };

  const findSubscription = async () => {
    try {
      startLoading("loading3")
      const subscriptionInfo = await SubscriptionAPI.findSubscription(selectedClub.clubId);
      setApiData("subscriptionFromPlatform", subscriptionInfo?.Data);
      finishLoading("loading3")
      if (typeof setSubscriptionStatus === 'function') {
        setSubscriptionStatus(subscriptionInfo.Data?.status);
      }
    } catch (error) {
      console.error(error);
      finishLoading("loading3")
    }
  };

  const handleUpgradeToPaid = async () => {
    const paid = catalogPaidPlan(apiResData.platformProducts);
    if (!paid?.planId) {
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Paid plan is not available.' }));
      return;
    }
    const switchBody = upgradeToPaidSwitchBody({
      userId: userInfo.userId,
      clubId: selectedClub.clubId,
      plan: paid,
      isYear: !!isYear[paid.planId],
      subQuantity: apiResData.subscriptionFromPlatform?.subscriptionQty || 1,
    });
    if (!switchBody.priceId) {
      dispatch(rootAction.setWarningMessage({
        id: Date.now(),
        type: 'error',
        content: 'Paid plan price is missing.',
      }));
      return;
    }
    try {
      startLoading("loading7");
      if (selectedClub?.calendarType) {
        try {
          await AccountSetupAPI.putCalendarType(
            calendarTypePayload(selectedClub.clubId, selectedClub.calendarType)
          );
        } catch (error) {
          // Plan switch still continues; calendar type is already saved from How You Charge.
        }
      }
      const response = await SubscriptionAPI.switchPlan(switchBody);
      const clientSecretKey = response?.Data?.clientSecretKey;
      if (!clientSecretKey) {
        dispatch(rootAction.setWarningMessage({
          id: Date.now(),
          type: 'error',
          content: 'Payment could not be started. Please try again.',
        }));
        return;
      }
      navigate('/subscription-connected', {
        state: platformUpgradeCheckoutState({
          switchBody,
          responseData: response.Data,
          clubId: selectedClub.clubId,
        }),
      });
    } catch (error) {
      dispatch(rootAction.setWarningMessage({
        id: Date.now(),
        type: 'error',
        content: switchApiErrorMessage(error),
      }));
    } finally {
      finishLoading("loading7");
    }
  };

  const handleSwitchToFree = async () => {
    const freePlan = catalogFreePlan(apiResData.platformProducts);
    if (!freePlan?.planId) {
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Free plan is not available.' }));
      return;
    }
    try {
      startLoading("loading7");
      if (selectedClub?.calendarType) {
        try {
          await AccountSetupAPI.putCalendarType(
            calendarTypePayload(selectedClub.clubId, selectedClub.calendarType)
          );
        } catch (error) {
          // Plan switch still continues; calendar type is already saved from How You Charge.
        }
      }
      await SubscriptionAPI.switchPlan(switchToFreeBody({
        userId: userInfo.userId,
        clubId: selectedClub.clubId,
        freePlanId: freePlan.planId,
      }));
      await findSubscription();
      await fetchSetupPlan();
      dispatch(rootAction.setWarningMessage({
        id: Date.now(),
        type: 'success',
        content: 'Free is scheduled for the end of this billing period.',
      }));
    } catch (error) {
      dispatch(rootAction.setWarningMessage({
        id: Date.now(),
        type: 'error',
        content: switchApiErrorMessage(error),
      }));
    } finally {
      finishLoading("loading7");
    }
  };

  const updateRegistrationFee = async () => {
    try {
      if (!registrationFee) {
        setRegError(true);
        return;
      }
      if (isNaN(registrationFee) || Number(registrationFee) < 0) {
        setRegError(true);
        return;
      }
      let regInfo = {
        clubId: selectedClub?.clubId,
        userId: userInfo?.userId,
        clubChargeAmount: registrationFee
      }
      startLoading("loading5");
      const response = await AccountSetupAPI.updateRegistrationFeeDetails(regInfo);
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: response.Data }));
      finishLoading("loading5");
    } catch (error) {
      finishLoading("loading5");
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please contact support' }));
    }
  }
  const resetState = () => {
    setPlanType('');
    setIsAdvanceBooking(false);
  }

  const handleAddPlan = async () => {
    try {
      let errors = {};
      if (planType === 'subscription') {
        if (!data.planName) {
          errors.planName = true;
        }
        if (!data.membershipAmount) {
          errors.membershipAmount = true;
        }
        if (isNaN(data.membershipAmount)) {
          errors.membershipAmount = true;
        }
        if (Number(data.membershipAmount) < 0) {
          errors.membershipAmount = true;
        }
      }
      if (isAdvanceBooking && !data.advanceBooking) {
        errors.advanceBooking = true;
      }
      if (isAdvanceBooking && isNaN(data.advanceBooking)) {
        errors.advanceBooking = true;
      }
      if (isAdvanceBooking && Number(data.advanceBooking) < 0) {
        errors.advanceBooking = true;
      }
      setErrorFields(errors);

      if (isApplyFee) {
        for (const a of weekdayInfo) {
          if (!a.amount) {
            setWeekDayAmount((prev) => [...prev, { amount: true }]);
            return;
          } else {
            if (isNaN(a.amount)) {
              setWeekDayAmount((prev) => [...prev, { amount: true }]);
              return;
            } else {
              if (a.amount < 0) {
                setWeekDayAmount((prev) => [...prev, { amount: true }]);
                return;
              }
              else {
                setWeekDayAmount((prev) => [...prev, { amount: false }]);
              }
            }
          }
        };

        for (const a of weekendInfo) {
          if (!a.amount) {
            setWeekEndAmount((prev) => [...prev, { amount: true }]);
            return;
          } else {
            if (isNaN(a.amount)) {
              setWeekEndAmount((prev) => [...prev, { amount: true }]);
              return;
            } else {
              if (a.amount < 0) {
                setWeekEndAmount((prev) => [...prev, { amount: true }]);
                return;
              }
              else {
                setWeekEndAmount((prev) => [...prev, { amount: false }]);

              }
            }
          }
        };
      }

      if ((planType === 'subscription' && !data.planName) || 
      (!planType) ||
      (planType === 'subscription' && !data.membershipAmount) || 
      (planType === 'subscription' && isNaN(data.membershipAmount)) || 
      (planType === 'subscription' && (Number(data.membershipAmount) < 0)) || (isAdvanceBooking && !data.advanceBooking) || (isAdvanceBooking && isNaN(data.advanceBooking)) || (isAdvanceBooking && Number(data.advanceBooking) < 0)) {
        return;
      }
      const productInfo = {
        planName: data.planName,
        planType: planType,
        membershipAmount: data.membershipAmount,
        userId: userInfo?.userId,
        clubId: selectedClub.clubId,
        weekdayInfo: isApplyFee ? JSON.stringify(weekdayInfo) : "{}",
        weekendInfo: isApplyFee ? JSON.stringify(weekendInfo) : "{}",
        advanceBooking: isAdvanceBooking ? isApplyFee ? data.advanceBooking : 0 : 0,
        planFor: 'PLAYER'
      }

      startLoading("loading1");
      setOpenAdd(false);
      await ProductAPI.postCreateProduct(productInfo)
      if (typeof setIsUpdated === 'function') {
        setIsUpdated(true);
      }
      setData('')
      resetState()
      setWeekdayInfo([{ startTime: '', endTime: '', amount: '' }]);
      setWeekendInfo([{ startTime: '', endTime: '', amount: '' }]);
      setRefreshProduct(true);
    } catch (error) {
      finishLoading("loading1")
      console.error("error occure in product");
    }
  }

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 200, // Set the max height of the dropdown
      },
    },
  };
  const timeDetails = [
    ...Array.from({ length: 12 }, (_, i) => `${i === 0 ? 12 : i}am`), // 12am to 11am
    ...Array.from({ length: 12 }, (_, i) => `${i === 0 ? 12 : i}pm`)  // 12pm to 11pm
  ];

  const resumeSubscription = async (subscriptionStripeId) => {
    try {
      startLoading("loading3")
      const subUpateInfo = {
        subscriptionId: subscriptionStripeId
      }
      const result = await SubscriptionAPI.resumeSubscription(subUpateInfo);
      setTimeout(() => {
        dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Your subscription is resumed successfully' }));
        setRefreshSubscription(true)
      }, 1000);
    } catch (error) {
      console.error(error);

      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Something went wrong' }));
    } finally {
      finishLoading("loading3");
    }
  }


  const handleUpdateIsPlanRequired = async (val) => {
    try {
      startLoading("loading3")
      const reqObj = {
        clubId: selectedClub.clubId,
        isPlanRequired: val
      }
      await AccountSetupAPI.updateIsPlanRequired(reqObj);
      getCurrentUser();
      setIsPlanRequired(val);
    } catch (error) {
      console.log(error);
    } finally {
      finishLoading("loading3")
    }
  };

  const currentPlanLabel = currentPlanName(apiResData.subscriptionFromPlatform, selectedClub);
  const isSetupWizard = typeof applySetupData === "function";
  const onFreePlan = isFreeClubPlan({
    freePlan: setupPlan?.freePlan,
    subscription: apiResData.subscriptionFromPlatform,
    selectedClub,
  });
  const showCurrentPlan = !isSetupWizard && (
    Boolean(currentPlanLabel)
    || onFreePlan
    || typeof setupPlan?.freePlan === "boolean"
    || Boolean(apiResData?.subscriptionFromPlatform)
    || selectedClub?.freePlanUser === true
  );
  const showPlatformCatalog = privileges?.MANAGE_PLATFORM_PLAN?.includes(Privileges.VIEW)
    && (!apiResData?.subscriptionFromPlatform || apiResData.platformProducts.length > 0);
  const platformCatalogReady = !(
    (loadingState.loading2 || loadingState.loading3 || loadingState.loading4)
    && !apiResData?.subscriptionFromPlatform
  );
  const catalogPlans = isSetupWizard
    ? apiResData.platformProducts
    : apiResData.platformProducts.filter((plan) => !isSelectedPlatformPlan(plan, currentPlanLabel));
  const showAvailableSection = showPlatformCatalog && (
    isSetupWizard || catalogPlans.length > 0 || !platformCatalogReady
  );
  const showPlayerPlans = clubShowsClubPlayerCatalog(selectedClub)
    && Boolean(apiResData?.subscriptionFromPlatform?.status);
  const canViewPlayerCatalog = privileges?.MANAGE_CLUB_PLAN?.includes(Privileges.VIEW)
    && clubShowsClubPlayerCatalog(selectedClub);
  const canViewActivationFee = privileges?.MANAGE_ONE_TIME_ACTIVATION_FEE?.includes(Privileges.VIEW)
    && (clubShowsCustomerPlans(selectedClub) && (hasClubCapabilityModel(selectedClub) || isPlanRequired));
  const showPlayerSection = showPlayerPlans && (
    !hasClubCapabilityModel(selectedClub) || canViewPlayerCatalog || canViewActivationFee
  );

  return (
    <div className='sub_plan_setting_container plan-page'>
      {(loadingState.loading3 || loadingState.loading7) && <Loader />}

      {!isSetupWizard && showCurrentPlan &&
        <header className="plan-page-hero">
          <p className="plan-page-kicker">Setup</p>
          <h1 className="plan-page-title">Plans</h1>
          <p className="plan-page-lead">Three lists on this page. Your SportMingle plan, SportMingle catalog, then custom plans members buy from this club.</p>
        </header>}

      {showCurrentPlan &&
        <PlanPageSection
          className="plan-page-active"
          testId="current-plan-section"
          step="1"
          kicker="SportMingle"
          title="Your plan"
          lead="What this club pays SportMingle. Free or Paid. Players do not buy this."
        >
          <div className="plan-page-active-grid">
            <div data-testid={onFreePlan ? "sportmingle-free-tile" : undefined}>
            <PlanSwitchPanel
              isFreePlan={onFreePlan}
              feeLabel={freeFeePhrase(planFees.freeFee) || planFees.free}
              {...planSwitchDates(apiResData.subscriptionFromPlatform || {}, setupPlan || {})}
              onConfirmUpgrade={handleUpgradeToPaid}
              onConfirmSwitchToFree={handleSwitchToFree}
              isBusy={loadingState.loading7}
              canAct={isClubOwner(userInfo)}
            />
            </div>
            {apiResData?.subscriptionFromPlatform &&
              <SubDetailsCard
                subscriptionDetails={apiResData?.subscriptionFromPlatform}
                defaultPayCard={defaultPayCard}
                selectedClub={selectedClub}
                resumeSubscription={resumeSubscription}
                userInfo={userInfo}
                privileges={privileges}
                startLoading={startLoading}
                finishLoading={finishLoading}
              />}
          </div>
        </PlanPageSection>}

      {showAvailableSection &&
        <PlanPageSection
          className="plan-page-available"
          testId="available-plans-section"
          step="2"
          kicker="SportMingle"
          title={isSetupWizard ? "Choose a SportMingle plan" : "SportMingle available plans"}
          lead={isSetupWizard
            ? "Pick Free to start today, or Paid when you are ready. This is SportMingle, not member court rates."
            : "Other SportMingle plans you can switch to. Players do not buy these."}
        >
          {!platformCatalogReady ?
            <SecondLoader />
            :
            <>
              {isSetupWizard &&
                <PlanCompare freeFeeLabel={planFees.free} paidFeeLabel={planFees.paid} />}
              <div className='sm_plan_setting_platform_plan_list'>
                {catalogPlans.map((plan) =>
                  <PlanCard
                    key={plan.planId}
                    planInfo={plan}
                    startLoading={startLoading}
                    finishLoading={finishLoading}
                    onToggle={(val) => handleChangeDuration(val, plan?.planId)}
                    isYear={!!isYear[plan?.planId]}
                    applySetupData={applySetupData}
                    isSelected={isSelectedPlatformPlan(plan, currentPlanLabel)}
                    hasCurrentPlan={Boolean(currentPlanLabel)}
                  />
                )}
              </div>
            </>}
        </PlanPageSection>}

      {showPlayerSection &&
        <PlanPageSection
          className="plan-page-player"
          testId="club-player-plans-section"
          step="3"
          kicker="This club"
          title="Your custom plans for members"
          lead={clubShowsHourlyCourtPlans(selectedClub)
            ? "Hourly court rates and memberships members buy from you. Card payouts need Financial Vendor (Stripe). This is not SportMingle."
            : "Memberships members buy from you. This is not your SportMingle plan."}
        >
          {clubNeedsConnectToGetPaid(selectedClub) && hourlyVendorReady === false && typeof applySetupData !== "function" &&
            <div className="plan-page-vendor-note" data-testid="hourly-vendor-required">
              <p>{HOURLY_COURT_VENDOR_REQUIRED}</p>
              <Button
                type="button"
                variant="contained"
                onClick={() => navigate(FINANCIAL_VENDOR_PATH)}
              >
                Go to Finances
              </Button>
            </div>}
          {!hasClubCapabilityModel(selectedClub) &&
          <div className='sm_is_plan_required_input'>
            <FormControlLabel
              sx={{ marginLeft: 1 }}
              control={<Checkbox
                disabled={apiResData.subscriptionDetails.length != 0 || !privileges?.MANAGE_CLUB_PLAN?.includes(Privileges.MODIFY)}
                checked={isPlanRequired}
                onChange={(e) => handleUpdateIsPlanRequired(e.target.checked)}
                className="reservation-calcel-checkbox"
              />}
              label="Would you like to start a monthly subscription for your club?"
            />
          </div>}

          {canViewPlayerCatalog &&
            <AddPlanComponent
              isLoading={loadingState.loading1}
              data={apiResData.subscriptionDetails}
              startLoading={startLoading}
              finishLoading={finishLoading}
              setRefreshProduct={setRefreshProduct}
              privileges={privileges}
              setOpenAdd={setOpenAdd}
            />
          }

          {canViewActivationFee &&
            <>
              {loadingState.loading5 ?
                <SecondLoader />
                :
                <div className='sub_plan_setting_reg_fee'>
                  <h1>One Time Activation Fee</h1>
                  <TextField
                    error={regError}
                    helperText={regError && "Please enter valid charge amount"}
                    value={registrationFee || ""}
                    onChange={(e) => {
                      setRegError(false);
                      setRegistrationFee(e.target.value)
                    }}
                    name="playerCharge"
                    className="add_plan_text_input"
                    label="Activation Fee Amount"
                    variant="outlined"
                  />
                  {privileges?.MANAGE_ONE_TIME_ACTIVATION_FEE?.includes(Privileges.MODIFY) &&
                    <Button
                      type='button'
                      className='save_registration_fee'
                      variant='contained'
                      onClick={updateRegistrationFee} >save</Button>}
                </div>
              }
            </>}
        </PlanPageSection>}

      <CustomDialog
        isOpen={openAdd}
        onClose={() => setOpenAdd(false)}
        onCancel={() => {
          setOpenAdd(false);
          setData('');
          setErrorFields('');
          setWeekDayAmount([]);
          setWeekEndAmount([]);
          setWeekdayInfo([{ startTime: '', endTime: '', amount: '' }]);
          setWeekendInfo([{ startTime: '', endTime: '', amount: '' }]);
        }}
        onSubmit={handleAddPlan}
        title="Enter Plan Details"
        submitBtnName='Add'
      >
        <div className='sm_add_plan_info_form'>
          <FormControl sx={{ marginBottom: 5 }}>
            <FormLabel
              style={{ fontWeight: 500, color: planType ? 'var(--hoverColorBold)' : 'black' }}
              id="demo-controlled-radio-buttons-group">Choose Plan Type:</FormLabel>
            <RadioGroup
              className='choose_plan_type_radio_btn'
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={planType}
              onChange={(val) => setPlanType(val.target.value)}
            >
              <FormControlLabel value="subscription" control={<Radio />} label="Recurring Subscription" />
              {!apiResData?.subscriptionDetails?.find((item) => item.planType === 'pay-as-you-go') && <FormControlLabel value="pay-as-you-go" control={<Radio />} label="Pay As You Go" />}
            </RadioGroup>
          </FormControl>
          {planType &&
            <div className="add_product_form">
              {planType === 'subscription' &&
                <>
                <TextField
                  error={errorFields.planName}
                  helperText={errorFields.planName && "Enter valid plan name"}
                  className='add_plan_text_input'
                  value={data.planName || ''}
                  onChange={handleData}
                  name='planName'
                  label="Plan Name*" />
                <TextField
                  error={errorFields.membershipAmount}
                  helperText={errorFields.membershipAmount && "Enter valid amount for plan"}
                  className='add_plan_text_input'
                  value={data.membershipAmount || ''}
                  onChange={handleData}
                  name='membershipAmount'
                  label="Membership amount*" />
                </>
              }
             
              <FormControlLabel
                sx={{ margin: 0, padding: 0 }}
                control={<Checkbox
                  sx={{ marginRight: 1, padding: 0 }}
                  checked={isApplyFee}
                  onChange={(e) => setIsApplyFee(e.target.checked)}
                  className="reservation-calcel-checkbox"
                />}
                label="Apply charges to each reservation."
              />
              {isApplyFee &&
                <>
                  <FormControlLabel
                    sx={{ margin: 0, padding: 0 }}
                    control={<Checkbox
                      sx={{ marginRight: 1, padding: 0 }}
                      onChange={(e) => setIsAdvanceBooking(e.target.checked)}
                      className="reservation-calcel-checkbox"
                    />}
                    label="Enable advance booking"
                  />
                  {isAdvanceBooking &&
                    <TextField
                      error={errorFields.advanceBooking}
                      helperText={errorFields.advanceBooking && "Enter valid advance booking value"}
                      className='add_plan_text_input'
                      value={data.advanceBooking || ''}
                      onChange={handleData}
                      name='advanceBooking'
                      label="Advance Booking(Days)" />}
                  <div className="subscription_weekday_time_details">
                    <h2>Enter Weekday Plan Details:</h2>
                    {weekdayInfo.map((info, index) =>
                      <div key={index} className='weekday_amount_time_details'>
                        <div className='weekday_amount_time_details_part1'>
                          <FormControl
                            className='weekday_time_input'
                          >
                            <InputLabel id="demo-simple-select-label">From</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={info.startTime || ''}
                              name='startTime'
                              label="From"
                              MenuProps={menuProps}
                              onChange={(event) => handleWeekInfo(index, event)}
                            >
                              {timeDetails?.map((time, index) =>
                                <MenuItem key={index} value={time}>{time}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                          <FormControl
                            className='weekday_time_input'
                          >
                            <InputLabel id="demo-simple-select-label">To</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={info.endTime || ''}
                              name='endTime'
                              onChange={(event) => handleWeekInfo(index, event)}
                              label="To"
                              MenuProps={menuProps}
                            >
                              {timeDetails?.map((time, index) =>
                                <MenuItem key={index} value={time}>{time}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </div>
                        <div className='weekday_amount_time_details_part2'>
                          <TextField
                            error={weekDayAmount[index]?.amount}
                            helperText={weekDayAmount[index]?.amount && "Please enter valid amount"}
                            className='add_plan_text_input'
                            value={info.amount || ''}
                            onChange={(event) => handleWeekInfo(index, event)}
                            name='amount'
                            label="amount" />
                          {weekdayInfo.length > 1 &&
                            <GrClose className='close_weekinfo_btn' onClick={() => handleRemoveWeekInfo(index)} />}
                        </div>
                      </div>)}
                    {weekdayInfo.length < 3 &&
                      <button onClick={() => setWeekdayInfo(prev => [...prev, { startTime: '', endTime: '', amount: '' }])} className='add_weekinfo_btn' >
                        <RiAddLargeLine className='add_weekinfo_icon' />
                      </button>}
                  </div>
                  <div className="subscription_weekday_time_details">
                    <h2>Enter Weekend Plan Details:</h2>
                    {weekendInfo.map((info, index) =>
                      <div key={index} className='weekday_amount_time_details'>
                        <div className='weekday_amount_time_details_part1'>
                          <FormControl
                            className='weekday_time_input'
                          >
                            <InputLabel id="demo-simple-select-label">From</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={info.startTime || ''}
                              name='startTime'
                              label="From"
                              MenuProps={menuProps}
                              onChange={(event) => handleWeekendInfo(index, event)}
                            >
                              {timeDetails?.map((time, index) =>
                                <MenuItem key={index} value={time}>{time}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                          <FormControl
                            className='weekday_time_input'
                          >
                            <InputLabel id="demo-simple-select-label">To</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={info.endTime || ''}
                              name='endTime'
                              onChange={(event) => handleWeekendInfo(index, event)}
                              label="To"
                              MenuProps={menuProps}
                            >
                              {timeDetails?.map((time, index) =>
                                <MenuItem key={index} value={time}>{time}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </div>
                        <div className='weekday_amount_time_details_part2'>
                          <TextField
                            error={weekEndAmount[index]?.amount}
                            helperText={weekEndAmount[index]?.amount && "Please enter valid amount"}
                            className='add_plan_text_input'
                            value={info.amount || ''}
                            onChange={(event) => handleWeekendInfo(index, event)}
                            name='amount'
                            label="amount" />

                          {weekendInfo.length > 1 &&
                            <GrClose className='close_weekinfo_btn' onClick={() => handleRemoveWeekendInfo(index)} />}
                        </div>

                      </div>)}
                    {weekendInfo.length < 3 &&
                      <button onClick={() => setWeekendInfo(prev => [...prev, { startTime: '', endTime: '', amount: '' }])} className='add_weekinfo_btn' >
                        <RiAddLargeLine className='add_weekinfo_icon' />
                      </button>}
                  </div>
                </>}
            </div>
          }
        </div>
      </CustomDialog>
    </div >
  )
}

export default PlanSetting